import React from 'react';
import PropTypes from 'prop-types';

const InputHoneypot = ({ captureFieldData }) => {
  const handleCaptureData = event => {
    captureFieldData(event);
  };

  return (
    <div style={{ display: 'none' }}>
      >
      <input
        name="honeypot"
        type="text"
        onChange={event => handleCaptureData(event)}
      />
    </div>
  );
};

InputHoneypot.propTypes = {
  captureFieldData: PropTypes.func,
};

export default InputHoneypot;



// WEBPACK FOOTER //
// ./src/components/form/inputs/input-honeypot/index.js